import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { h2, paragraph } from '@helpers/typography';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Group = styled.div `
  border: 2px solid ${brand.orange};

  &:not(:first-child) {
    margin-top: 30px;
  }

  @media ${from(Device.MobileLarge)} {
    padding-left: 43px;
  }
`;
const GroupName = styled.h2 `
  position: relative;
  ${h2};
  padding: 4px 15px;
  margin-bottom: 0;
  border-bottom: 1px solid ${brand.grey.grey13};

  @media ${from(Device.MobileLarge)} {
    padding: 8px 28px;
    border-left: 1px solid ${brand.grey.grey13};
    border-bottom: none;

    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      background-color: ${brand.orange};
      z-index: 1;
      transform: translate(-50%, 50%) translate(-1px, -1px);
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: -1px;
      width: calc(100% + 45px);
      height: 2px;
      background-color: ${brand.grey.grey13};
      transform: scaleY(0.5);
    }
  }
`;
const People = styled.div ``;
const Person = styled.div `
  ${h2};
  font-size: ${fluid(18, 24)};
  line-height: ${fluid(24, 30)};
  margin-bottom: 0;
  padding: 4px 15px;

  @media ${from(Device.MobileLarge)} {
    padding: 8px 28px;
    border-left: 1px solid ${brand.grey.grey13};
  }

  &:first-child {
    padding-top: 16px;
  }

  &:last-child {
    padding-bottom: 16px;
  }
`;
const ProfileUrl = styled(LinkButton) `
  padding-top: 0;
  padding-bottom: 0;

  &&& {
    --buttonFgColor: ${brand.orange};
    --buttonHeight: auto;
    color: ${brand.orange};
    text-decoration: underline;
  }

  ${ButtonStyles.Text} {
    font-size: ${fluid(18, 24)};
    line-height: ${fluid(24, 30)};
  }

  svg path:first-child {
    stroke: ${brand.orange};
  }
`;
const JobTitle = styled.span `
  ${paragraph};
  display: block;
  margin-bottom: 0;
  ${fonts.agBook.regular};

  font-size: ${fluid(16, 22)};
  line-height: ${fluid(22, 30)};
`;
export const ProfilesStyles = {
    Container,
    Group,
    GroupName,
    JobTitle,
    People,
    Person,
    ProfileUrl,
};
